@if ($visible()) {
  @if ($backdrop() && $mode() !== 'push') {
    <div
      class="side-dialog-backdrop"
      (click)="onBackdropClick($event)"
      (animate.enter)="onBackdropEnter($event)"
      (animate.leave)="onBackdropLeave($event)"
    ></div>
  }
  <div
    class="side-dialog-panel"
    [class.position-left]="$position() === 'left'"
    [class.mode-push]="$mode() === 'push'"
    [style.width]="$width() || null"
    role="dialog"
    (animate.enter)="onPanelEnter($event)"
    (animate.leave)="onPanelLeave($event)"
  >
    <ng-content />
  </div>
}
